<template>
    <div class="reportList padding-20 bgc box-shadow">
        <div class="topClass" align="right">
            <el-select v-model="typeValue" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-date-picker class="item" v-model="time.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
            <el-input placeholder="请输入记录人关键字" v-model="searchName" style="width: 220px"></el-input>
            <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column label="记录人" class-name="title" width="180">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img :src="scope.row.headimageurl?scope.row.headimageurl:require('@/common/images/user.png')">
                            <div>{{scope.row.customername}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="notestypetext" label="笔记类型" class-name="center"></el-table-column>
                <el-table-column prop="assetname" label="课程/课时名称" class-name="center" :show-overflow-tooltip="true" width="270"></el-table-column>
                <el-table-column prop="content" label="笔记内容" class-name="center" :show-overflow-tooltip="true" width="270"></el-table-column>
                <el-table-column label="状态" class-name="center">
                    <template slot-scope="scope">
                        <div class="imgStatus">
                            <span v-if="scope.row.status === 0" style="color: #606266">无效</span>
                            <span v-if="scope.row.status === 1" style="color: #67C23A">有效</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="笔记时间" class-name="center" width="160"></el-table-column>
                <el-table-column label="操作" label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                            <el-button @click="handleDetails(scope.row)" type="text" size="small">{{scope.row.status===0?'恢复':'屏蔽'}}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="searchClick" ref="page"></page>
        </div>
    </div>
</template>

<script>
    import {getAllNotesPage,updateNotesStatus} from 'api/curriculumApi'
    import Upload from 'base/upload/upload'
    import {reportMgtCode} from 'api/enumCode'
    import Share from 'base/share/share'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    import {promiseUrlToQRCode} from 'common/js/tools'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'curriculumNote',
        data() {
            return {
                id:this.$route.query.innerid,
                form:{}, //表单
                typeList:[
                    {label:'全部',value:''},
                    {label:'课程',value:'1'},
                    {label:'图文',value:'2'},
                    {label:'报告',value:'3'},
                ],
                typeValue:'',
                searchName:'', //记录人
                time: {             // 开始/结束时间
                    date: ''
                },
                total: 0,
                tableData: []
            }
        },
        mounted() {
            this._getList()
        },
        methods: {
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            _getList() {
                this.setLoading(true);
                getAllNotesPage({
                    data: {
                        courseid:this.id,
                        page: 1,
                        pageSize: 10
                    },
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            searchClick() {
                this.setLoading(true);
                let searchDate = this.time;
                let params = {
                    courseid:this.id,
                    notestype: this.typeValue,
                    customername: this.searchName,
                    begintime: searchDate.date[0]?fecha.format(searchDate.date[0], 'yyyy-MM-dd'):'',
                    endtime: searchDate.date[1]?fecha.format(searchDate.date[1], 'yyyy-MM-dd'):'',
                };
                getAllNotesPage({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 屏蔽/恢复
            handleDetails(row){
                this.setLoading(true);
                let params = {
                    innerid: row.innerid,
                    status: row.status===0?1:0,
                };
                updateNotesStatus({
                    data: params,
                    success: data => {
                        this.setLoading(false);
                        this._getList()
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
                'setPage'
            ])
        },
        watch: {},
        computed: {
            ...mapGetters([
                'page',
            ])
        },
        components: {
            Page, Share,  Upload
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .reportList{
        .topClass{
            float:right;
            display: flex;
            margin-bottom: 40px;
            .el-input__inner,.el-input,.el-select{
                margin-right: 20px;
                height: 36px;
            }
            .el-select{
                width: 110px;
            }
            .el-button, .el-button--mini{
                height: 36px;
            }
        }
    }
    .result-list{
        .imageText{
            img{
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-right: 12px;
            }
        }
    }
    .reportList .center {
        text-align: center;
    }
    /*样式更改 日期选择*/
    .el-range-editor.el-input__inner{
        padding: 0 10px;
        width: 240px;
    }
    .topicIndex .el-date-editor {
        margin-right: 20px;
    }
    /*评价详情*/
    .details_box{
        display: flex;
        flex-direction: column;
        .det_head{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 20px;
            img{
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-right: 10px;
                background: red;
            }
        }
        .content_box{
            .title{
                margin-bottom: 20px;
                display: flex;
                span{
                    width:2px;
                    height:16px;
                    background:rgba(64,158,255,1);
                    margin-right: 10px;
                    display: inline-block;
                }
            }
            .content_text{
                .first_row{
                    display: flex;
                }
                p,.first_row{
                    line-height: 23px;
                    margin-bottom: 10px;
                    display: flex;
                    color: #333;
                    b{
                        font-weight: normal;
                        width: 80px;
                        color: #666;
                    }
                }
            }
        }
    }
</style>

